import cn from 'classnames';
import React from 'react';
import Close from '../../images/close.svg';
import { FORM_TYPE } from '../../utils/analytics/constants';
import ResourceForm from '../Blog/ResourceForm';
import DataConsultForm from '../BusinessIntelligence/DataConsultForm';
import PrismForm from '../PrismNewPage/PrismForm';
import WebinarsRegisterForm from '../Webinars/WebinarsRegisterForm';

interface FormModalProps {
  setActiveDataConsultModal?: any;
  setActiveModal: React.Dispatch<React.SetStateAction<boolean>>;
  data?: any;
  formType?: string;
  title?: string;
  formId?: string;
  pageTitle?: string;
  eventId?: string;
  termsAndConditions?: {
    title: string;
    translation: {
      childMdx: {
        body: string;
      };
    };
  };
  marketplaceAvailable?: string;
}

const FormModal: React.FC<React.PropsWithChildren<FormModalProps>> = props => {
  const {
    data,
    formType,
    title,
    setActiveDataConsultModal,
    setActiveModal,
    formId,
    pageTitle,
    eventId,
    termsAndConditions,
    marketplaceAvailable,
  } = props;
  return (
    <>
      <div
        onClick={() =>
          formType !== FORM_TYPE.DATA_CONSULT
            ? setActiveModal(false)
            : setActiveDataConsultModal({ variant: '', isOpen: false })
        }
        className="fixed top-0 h-full w-full bg-gray-4-dark bg-opacity-80 z-50"
      ></div>
      <div
        className={cn(
          'fixed z-50 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 flex justify-center w-[90%] max-h-[600px] lg:max-h-[80%]',
          formType === FORM_TYPE.WEBINAR ? 'max-w-6xl' : 'max-w-[750px]'
        )}
      >
        <div className="rounded-2xl overflow-hidden w-full bg-white px-4 py-16 sm:py-12 flex flex-col items-center justify-start overflow-y-auto">
          {formType !== FORM_TYPE.STARTUP && (
            <p className="text-center text-indigo-3-dark text-3xl font-semibold mt-0">
              {title}
            </p>
          )}
          {formType === FORM_TYPE.RESOURCE ? (
            <ResourceForm
              termsAndConditions={
                termsAndConditions?.translation?.childMdx?.body
              }
              resource={data}
              setActiveModal={setActiveModal}
            />
          ) : formType === FORM_TYPE.WEBINAR ? (
            <WebinarsRegisterForm
              eventId={eventId}
              formId={formId}
              pageTitle={pageTitle}
              setActiveModal={setActiveModal}
              termsAndConditions={
                termsAndConditions?.translation?.childMdx?.body
              }
            />
          ) : formType === FORM_TYPE.PRISM  ? (
            <PrismForm
              termsAndConditions={
                termsAndConditions?.translation?.childMdx?.body
              }
              formType={formType}
              formId={formId}
              marketplaceAvailable={marketplaceAvailable}
            />
          ) : (
            <DataConsultForm
              termsAndConditions={
                termsAndConditions?.translation?.childMdx?.body
              }
              consultData={data}
            />
          )}
        </div>
        <button
          onClick={() =>
            formType !== FORM_TYPE.DATA_CONSULT
              ? setActiveModal(false)
              : setActiveDataConsultModal({ variant: '', isOpen: false })
          }
          className="absolute bg-indigo-1 h-10 w-10 -top-3 -right-3 rounded-full flex items-center justify-center focus:outline-none z-50"
        >
          <Close />
        </button>
      </div>
    </>
  );
};

export default React.memo(FormModal);
